const awsmobile = {
    aws_project_region: 'us-east-1',
    aws_cognito_identity_pool_id: 'us-east-1_mXJBEybdj',
    aws_cognito_region: 'us-east-1',
    aws_user_pools_id: 'us-east-1_mXJBEybdj',
    aws_user_pools_web_client_id: '1r5asu5vuko5kbnh3j1nrvv349',
};

export default awsmobile;
